import React, { memo } from 'react';
import { Route, Routes } from 'react-router';

import EditSonar from './edit-sonar/EditSonar';
import EditResonance from './edit-resonance/EditResonance';
import EditScout from './edit-scout/EditScout';
import { PROJECT_TYPES } from '../../constants';
import EditGenie from './edit-genie/EditGenie';
import EditGenieGo from './edit-genie-go/EditGenieGo';
import EditId8 from './edit-id8/EditId8';
import EditActiv8 from './edit-activ8/EditActiv8';

const EditProject = () => {
  return (
    <Routes>
      <Route path={`/${PROJECT_TYPES.SONAR.toLowerCase()}/:id`} exact element={<EditSonar />} />
      <Route path={`/${PROJECT_TYPES.RESONANCE.toLowerCase()}/:id`} exact element={<EditResonance />} />
      <Route path={`/${PROJECT_TYPES.SCOUTV2.toLowerCase()}/:id`} exact element={<EditScout />} />
      <Route path={`/${PROJECT_TYPES.GENIE.toLowerCase()}/:id`} exact element={<EditGenie />} />
      <Route path={`/genie-go/:id`} exact element={<EditGenieGo />} />
      <Route path={`/${PROJECT_TYPES.ID8.toLowerCase()}/:id`} exact element={<EditId8 />} />
      <Route path={`/${PROJECT_TYPES.ACTIV8.toLowerCase()}/:id`} exact element={<EditActiv8 />} />
    </Routes>
  );
};

export default memo(EditProject);
